import axios from "axios"
axios.defaults.timeout = 30 * 1000
const baseUrl = "https://fc-mp-af2ae419-8d72-4586-b078-94a30e971439.next.bspapp.com"
const service = axios.create({
	// baseURL: baseUrl, // 设置默认 base URL（来自 .env）
	timeout: 300000, // 超时时间（5分钟，适应视频生成长耗时）
	// withCredentials: false // 是否携带 cookie
})


// 请求拦截器
// service.interceptors.request.use(
//   config => {
//     const token = localStorage.getItem('token')
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`
//     }
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )


// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
	return res

    
  },
  error => {
    return Promise.reject(error)
  }
)


async function request(url,params,method,config){
	 switch (method) {
	        case 'GET':
	            return axios.get(url, {params, ...config})
	        case "POST":
	            return axios.post(url, params, config)
	        case "PUT":
	            return axios.put(url, params, config)
	        case "DELETE":
	            return axios.delete(url, {params, ...config})
	        default:
	            return axios.get(url, {params, ...config})
				// return axios.get(url, params, ...config)
	    }
}
export default service